import { ElementTypes, FeatureTypes, MapColors } from '../enums';

export const ALBERTA = { lat: 51.013117, lng: -114.074155 };

const MAP_STYLES = [
  {
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.Gray }],
  },
  {
    elementType: ElementTypes.LabelsIcon,
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFillDarkest }],
  },
  {
    elementType: ElementTypes.LabelsTextStroke,
    stylers: [{ color: MapColors.GreyLabelsTextStroke }],
  },
  {
    featureType: FeatureTypes.AdministrativeLandParcel,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFillLight }],
  },
  {
    featureType: FeatureTypes.PointOfInterest,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.GreyGeometry }],
  },
  {
    featureType: FeatureTypes.PointOfInterest,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFillDark }],
  },
  {
    featureType: FeatureTypes.PointOfInterestPark,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.GreyGeometryPark }],
  },
  {
    featureType: FeatureTypes.PointOfInterestPark,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFill }],
  },
  {
    featureType: FeatureTypes.Road,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.White }],
  },
  {
    featureType: FeatureTypes.RoadArterial,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFillDark }],
  },
  {
    featureType: FeatureTypes.RoadHighway,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.GreyGeometryLight }],
  },
  {
    featureType: FeatureTypes.RoadHighway,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFillDarkest }],
  },
  {
    featureType: FeatureTypes.RoadLocal,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFill }],
  },
  {
    featureType: FeatureTypes.TransitLine,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.GreyGeometryTransitLine }],
  },
  {
    featureType: FeatureTypes.TransitStation,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.GreyGeometry }],
  },
  {
    featureType: FeatureTypes.Water,
    elementType: ElementTypes.Geometry,
    stylers: [{ color: MapColors.Blue }],
  },
  {
    featureType: FeatureTypes.Water,
    elementType: ElementTypes.LabelsTextFill,
    stylers: [{ color: MapColors.GreyLabelsTextFill }],
  },
];

export const icons = {
  STROKE_BLUE: '/img/icons/map-pin-blue-stroke.svg',
  BODE: '/img/icons/map-pin-bode.svg',
  BODE_GROUP: '/img/icons/map-pin-blue-stroke.svg',
  NOT_BODE: '/img/icons/map-pin-non-bode.svg',
  BODE_SOLD: '/img/icons/sold-listing-pin.svg',
  BODE_SOLD_GROUP: '/img/icons/group-sold-listing-pin-green.svg',
  SOLD_GROUP: '/img/icons/group-sold-listings-pin.svg',
  DOT_MARKER: '/img/icons/map-pin-dot.png',
};

export const defaultMapOptions = {
  zoom: 10,
  mapTypeId: 'roadmap',
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  gestureHandling: 'cooperative',
  styles: MAP_STYLES,
};

export default {
  defaultMapOptions,
  icons,
  ALBERTA,
};
